import styled, { css } from "styled-components";

export const SelectRoot = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectButton = styled.button`
  width: 100%;
  height: 42px;
  border-radius: 12px;
  border: 1px solid #d6d9e2;
  background: #ffffff;

  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  cursor: pointer;
  user-select: none;

  transition: background 120ms ease, border-color 120ms ease,
    box-shadow 120ms ease;

  &:hover {
    background: #fbfbfd;
    border-color: #c9cedb;
  }

  &:focus {
    outline: none;
    border-color: #9aa6c1;
    box-shadow: 0 0 0 4px rgba(27, 77, 214, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SelectValue = styled.span<{ $muted?: boolean }>`
  font-size: 14px;
  font-weight: 700;
  color: ${({ $muted }) => ($muted ? "#6b7280" : "#111827")};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectChevron = styled.span<{ $open?: boolean }>`
  width: 9px;
  height: 9px;
  flex-shrink: 0;

  border-right: 2px solid #6b7280;
  border-bottom: 2px solid #6b7280;

  transform: ${({ $open }) =>
    $open ? "rotate(-135deg)" : "rotate(45deg)"};

  transition: transform 120ms ease;
`;

export const SelectPopover = styled.div`
  position: absolute;
  z-index: 99999;
  left: 0;
  right: 0;
  margin-top: 8px;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;

  box-shadow: 0 16px 40px rgba(16, 24, 40, 0.16);
  overflow: hidden;
`;

export const SelectList = styled.div`
  max-height: 240px;
  overflow-y: auto;
  padding: 6px;

  /* Scrollbar clean */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 999px;
    border: 3px solid #ffffff;
  }
`;

export const SelectOption = styled.div<{
  $active?: boolean;
  $selected?: boolean;
}>`
  padding: 10px 12px;
  border-radius: 10px;

  font-size: 14px;
  font-weight: 700;
  color: #111827;

  cursor: pointer;
  user-select: none;

  transition: background 120ms ease, color 120ms ease;

  ${({ $active }) =>
    $active &&
    css`
      background: #f3f4f6;
    `}

  ${({ $selected }) =>
    $selected &&
    css`
      background: #eef2ff;
      color: #1b4dd6;
    `}
`;

export const SelectEmpty = styled.div`
  padding: 12px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
`;
